import Moment from 'moment';
import { extendMoment } from 'moment-range';


export function calculateSubtotal(rentable, count, startMoment, endMoment) {
    let billableUnits = calculateBillableUnits(rentable, startMoment, endMoment);
    return billableUnits * rentable.renting_charge_amount * count;
}

export function nightsBetweenDates(startMoment, endMoment) {
    var nights = 0;
    startMoment.startOf('day');
    endMoment.startOf('day');
    while(startMoment.isBefore(endMoment)) {
        nights += 1;
        startMoment.add(1, 'day');
    }
    return nights;
}

export function calculateBillableUnits(rentable, startMoment, endMoment) {
    switch (rentable.renting_charge_type) {
        case 'BOOKING':
            return 1;
        case 'DAY':
            return endMoment.diff(startMoment, 'days') + 1;
        case 'NIGHT':
            if (!startMoment || !endMoment) {
                return null;
            }
            return nightsBetweenDates(startMoment, endMoment);
        case 'HOUR':
            return Math.ceil(endMoment.diff(startMoment, 'hours', true));
        default:
            throw new Error('Invalid charging type');
    }
};

export function formatRentablePrice(vueApp, rentable) {
    return vueApp.$t('item.renting_charge', {
        amount: rentable.renting_charge_amount,
        unit: vueApp.$t('item.renting_charge_unit_' + rentable.renting_charge_type)
    });
}

export function dateMatchesPricingRule(dateMoment, pricingRules) {
    const moment = extendMoment(Moment);
    const matches = pricingRules.filter((rule) => {
        if (!rule.weekdays && !(rule.period_start && rule.period_end)) {
            console.debug('Skip incomplete pricing rule', [rule]);
            return false;
        }

        if (rule.period_start && rule.period_end) {
            if (!moment.range(rule.period_start, rule.period_end).contains(dateMoment)) {
                return false;
            }
        }

        if (rule.weekdays) {
            if (rule.weekdays.split(',').indexOf('' + dateMoment.isoWeekday()) === -1) {
                return false;
            }
        }

        return true;
    });

    if (matches.length === 1) {
        return matches[0];
    } else if (matches.length > 1) {
        console.debug('Multiple pricing rules applicable! This should be due to wrong settings', matches);
    }
    return false;
}